import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconFileMove = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 20.157 5.204 L 11.896 5.204 L 9.832 3.14 L 3.635 3.14 C 2.5 3.14 1.571 4.069 1.571 5.204 L 1.571 17.596 C 1.571 18.731 2.5 19.661 3.635 19.661 L 20.157 19.661 C 21.293 19.661 22.223 18.731 22.223 17.596 L 22.223 7.271 C 22.223 6.135 21.293 5.204 20.157 5.204 Z M 20.157 17.596 L 3.635 17.596 L 3.635 5.204 L 8.976 5.204 L 10.43 6.662 L 11.04 7.271 L 20.157 7.271 L 20.157 17.596 Z M 12.062 11.401 L 7.766 11.401 L 7.766 13.465 L 12.062 13.465 L 10.421 15.109 L 11.887 16.563 L 16.027 12.444 L 11.887 8.302 L 10.43 9.76 L 12.062 11.401 Z",
		fill: "currentColor",
		style: {}
	})
});
export default SvgIconFileMove;
